import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';

import Text from '../../elements/text/Text';

const StyledText = styled(Text)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const StepTitle = ({ title }) => {
  return <StyledText subtitleBold align="center" text={title} />;
};

StepTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default StepTitle;
